import { useState, useEffect } from 'react';
import axios from 'axios';

export default function RequestReset({ initialUsername = '', onClose }) {
  const [username, setUsername] = useState(initialUsername);
  const [status, setStatus] = useState(null); // { type: 'success'|'error'|'info', msg }
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (initialUsername) setUsername(initialUsername);
  }, [initialUsername]);

  const handleSubmit = async (e) => {
    e && e.preventDefault();
    if (!username.trim()) {
      setStatus({ type: 'error', msg: 'Please enter a username' });
      return;
    }
    setLoading(true);
    setStatus(null);
    try {
      const res = await axios.post('/api/forgotpassword', { username });
      setStatus({ type: 'success', msg: res.data?.message || 'Password reset email sent' });
      // auto-close after success
      setTimeout(() => {
        if (typeof onClose === 'function') onClose();
      }, 1500);
    } catch (err) {
      const code = err?.response?.status;
      if (code === 404) setStatus({ type: 'error', msg: 'User not found' });
      else setStatus({ type: 'error', msg: err?.response?.data?.message || 'Request failed' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ width: '100%' }}>
      <form onSubmit={handleSubmit} className="auth-form">
        <div>
          <h3 className="auth-card__title" style={{ fontSize: '1.45rem', paddingLeft: '1rem' }}>
            Forgot password?
          </h3>
          <p className="auth-card__copy" style={{ marginBottom: 0, paddingLeft: '1rem' }}>
            We’ll send a reset link to your inbox.
          </p>
        </div>

        <div className="auth-field">
          <label className="auth-label" style={{ paddingLeft: '1rem' }}>
            Username
          </label>
          <div style={{ paddingLeft: '1rem', paddingRight: '1rem', marginBottom: '0.5rem' }}>
            <input
              className="auth-input"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
        </div>

        <div
          className="auth-actions"
          style={{ paddingLeft: '1rem', paddingRight: '1rem', paddingBottom: '1rem' }}
        >
          <button type="submit" disabled={loading} className="auth-submit">
            {loading ? 'Sending…' : 'Send reset link'}
          </button>
          {typeof onClose === 'function' && (
            <button type="button" onClick={() => onClose()} className="auth-secondary">
              Cancel
            </button>
          )}
        </div>
        {status && (
          <div className={`auth-status ${status.type === 'error' ? 'is-error' : 'is-success'}`}>
            {status.msg}
          </div>
        )}
      </form>
    </div>
  );
}
